import { Customer } from 'server/shared/models/customer';
import { Invitee } from 'server/shared/models/invitee';
import { Job } from 'server/shared/models/job';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';

export function getInviteesOfJob(
  job: Job,
  invitees: Invitee[],
  ownCustomerId: string,
  sharedPoolCustomers: Customer[],
  nameSearch?: string,
): Invitee[] {
  return invitees.filter((invitee) => {
    const isOwnInvitee = invitee.customer.id == ownCustomerId;
    const isSharedInvitee = sharedPoolCustomers.some(
      (customer) => customer._id == invitee.customer.id,
    );
    const isTransferredInvitee =
      [
        InviteeStatusEnum.BOOKED,
        InviteeStatusEnum.CANCELED,
        InviteeStatusEnum.POSSIBLE_CANDIDATE,
      ].includes(invitee.status) && job.customer.id == ownCustomerId;
    const isInviteeOfOwnedOrganisation =
      invitee.status === InviteeStatusEnum.BOOKED ||
      (invitee.status === InviteeStatusEnum.CANCELED &&
        job.ownerCustomerIds?.includes(ownCustomerId));
    const canAccessInvitee =
      isOwnInvitee ||
      isTransferredInvitee ||
      isSharedInvitee ||
      isInviteeOfOwnedOrganisation;
    if (nameSearch) {
      return (
        canAccessInvitee &&
        (invitee.personalData.firstName
          .toLowerCase()
          .includes(nameSearch.toLowerCase()) ||
          invitee.personalData.lastName
            .toLowerCase()
            .includes(nameSearch.toLowerCase()) ||
          invitee.personalData.email
            .toLowerCase()
            .includes(nameSearch.toLowerCase()) ||
          invitee.personalData.phone
            ?.toLowerCase()
            ?.includes(nameSearch.toLowerCase()))
      );
    }
    return (
      isOwnInvitee ||
      isTransferredInvitee ||
      isSharedInvitee ||
      isInviteeOfOwnedOrganisation
    );
  });
}
